import { t } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { StatusPage } from '@/components/status-page';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { sanitizeRedirect } from '@/lib/routes';

/**
 * Where an admin-only route sends an actor who is signed in but not allowed.
 *
 * Public on purpose: the page is reached *because* the guard refused, and putting it behind
 * another guard would turn "no permission" into a login loop.
 */
export const Route = createFileRoute('/forbidden')({
  validateSearch: (search: Record<string, unknown>) => ({
    from: sanitizeRedirect(search.from),
  }),
  component: ForbiddenPage,
});

function ForbiddenPage() {
  useDocumentTitle(t('无访问权限'));
  return <StatusPage status={403} />;
}
